
import React from 'react'

import { SvgIcon } from '@mui/material'

export const HourGlassIcon = ({sx,...props}) => {
    return (
        <SvgIcon viewBox='0 0 24 24' {...{ sx: sx?.color ? { ...sx, stroke: sx.color, color: 'rgba(0,0,0,0.01)' } : sx, ...props }}>
            <path xmlns="http://www.w3.org/2000/svg" d="M9.39469 18.3085H14.6061M17.349 21.5999H6.65183C6.04589 21.5999 5.55469 21.1087 5.55469 20.5028V17.5719C5.55469 17.3377 5.62964 17.1096 5.76857 16.9211L8.91513 12.6507C9.20031 12.2637 9.20031 11.7361 8.91513 11.3491L5.76857 7.07874C5.62964 6.89019 5.55469 6.66213 5.55469 6.42792V3.49705C5.55469 2.89111 6.0459 2.3999 6.65183 2.3999H17.0747C17.6806 2.3999 18.1718 2.89111 18.1718 3.49705V6.44906C18.1718 6.67016 18.105 6.88611 17.9802 7.0686L15.0461 11.3568C14.7826 11.7419 14.7915 12.2515 15.0683 12.6272L18.2322 16.9211C18.3712 17.1096 18.4461 17.3377 18.4461 17.5719V20.5028C18.4461 21.1087 17.9549 21.5999 17.349 21.5999Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </SvgIcon>
    )
}
